import { PayableTypes } from '@efex-services/client/types';

const ALLOWED_STATUS = [
  PayableTypes.PENDING_TO_APPROVE,
  PayableTypes.PENDING_TO_APPROVE_BY_USER,
] as PayableTypes[];

export const ALLOWED_STATUS_FORWARDS = [
  // PayableTypes.PENDING_TO_PROCESS_SCHEDULED_PAYMENT, // TODO: remove this when forward logic is migrated to new view
] as PayableTypes[];

export default ALLOWED_STATUS;
